/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.InventoryReturns {
    angular.module("meevo.plugins.inventoryReturns", []);
}